import { defineStore } from 'pinia'
import { ref } from 'vue'
import { API_CONFIG } from '../api/config'
import { BASE_URL } from '../api/environment'

export const useEmpresaStore = defineStore(
    'empresa',
    () => {
        const empresaAtual = ref(null)
        const listaEmpresas = ref([])
        const isAdmin = ref(false);

        function applyActiveTheme() {
            const theme = empresaAtual.value?.company_color || 'defaultTheme';
            document.documentElement.setAttribute('data-theme', theme);
        }
        function definirEmpresaAtual(empresa) {
            if (empresa) {
                const empresaEncontrada = listaEmpresas.value.find(
                    (e) => e.user_company_uuid === empresa,
                )
                if (empresaEncontrada) {
                    let logo = null
                    if (empresaEncontrada.company_logo_path) {
                        logo = API_CONFIG.baseUrl + empresaEncontrada.company_logo_path
                    }


                    empresaAtual.value = {
                        id: empresaEncontrada.company_id,
                        user_company_uuid: empresaEncontrada.user_company_uuid,
                        company_name: empresaEncontrada.company_name,
                        company_logo_path: empresaEncontrada.company_logo_path,
                        company_role: empresaEncontrada.company_role,
                        company_color: empresaEncontrada.company_color || 'defaultTheme',
                        system_role: empresaEncontrada.system_role,
                        access: empresaEncontrada.access,
                        tenant_id: empresaEncontrada.tenant_id,
                    }

                    if (empresaEncontrada.system_role === 'super') {
                        isAdmin.value = true;
                    }
                }
            } else {
                empresaAtual.value = null
            }
            applyActiveTheme();
        }

        function getUserCompanyId() {
            return empresaAtual.value?.user_company_uuid;
        }

        function getCompanyRole() {
            return empresaAtual.value.company_role;
        }

        function getAcess() {
            return empresaAtual.value.access;
        }
        function atualizarEmpresaAtual(data) {
            empresaAtual.value = {
                id: data.id,
                user_company_uuid: this.getUserCompanyId(),
                company_name: data.name,
                company_logo_path: this.getLogo(),
                company_role: this.getCompanyRole(),
                company_color: data.color_palette,
                system_role: this.getSystemRole(),
                access: this.getAcess(),
                tenant_id: this.getTenantId(),
            }
            applyActiveTheme();
        }

        function getSystemColor() {
            return empresaAtual.value.company_color == undefined ? "defaultTheme" : empresaAtual.value.company_color;
        }
        function getId() {
            return empresaAtual.value.id;
        }

        function getTenantId() {
            return empresaAtual.value.tenant_id;
        }

        function getSystemRole() {
            return empresaAtual.value.system_role
        }

        function setSystemTheme(color) {
            const empresaIndex = this.getIndexCompany();
            listaEmpresas.value[empresaIndex].company_color = color;
            empresaAtual.value.company_color = color;
        }

        function setLogo(urlCompletaDaLogo) {
            const empresaIndex = getIndexCompany();
            if (empresaIndex !== -1) {

                const caminhoRelativo = urlCompletaDaLogo.replace(BASE_URL, '');

                listaEmpresas.value[empresaIndex].company_logo_path = caminhoRelativo;

                if (empresaAtual.value) {
                    empresaAtual.value.company_logo_path = caminhoRelativo;
                }
            }
        }

        function getLogo() {

            if (!empresaAtual.value) return null;

            const empresaIndex = getIndexCompany();


            if (empresaIndex === -1) return null;

            const empresa = listaEmpresas.value[empresaIndex];


            return empresa ? empresa.company_logo_path : null;
        }

        function getIndexCompany() {

            if (!empresaAtual.value) return -1;

            const userCompanyId = getUserCompanyId();
            if (!userCompanyId) return -1;

            return listaEmpresas.value.findIndex(empresa => empresa.user_company_uuid == userCompanyId);
        }

        function removeLogo() {
            const empresaIndex = getIndexCompany();
            if (empresaIndex !== -1) {

                listaEmpresas.value[empresaIndex].company_logo_path = null;
                if (empresaAtual.value) {
                    empresaAtual.value.company_logo_path = null;
                }
            }
        }

        function definirListaEmpresas(empresas) {
            if (Array.isArray(empresas)) {
                listaEmpresas.value = empresas.map((empresa) => ({
                    user_company_uuid: empresa.user_company_uuid,
                    company_id: empresa.company_id,
                    company_name: empresa.company_name,
                    company_color: empresa.company_color,
                    company_logo_path: empresa.company_logo_path,
                    company_role: empresa.company_role,
                    system_role: empresa.system_role,
                    access: empresa.access,
                    tenant_id: empresa.tenant_id,
                }))
            } else {
                listaEmpresas.value = []
            }
        }

        function limparDadosEmpresa() {
            empresaAtual.value = null
            listaEmpresas.value = []
            document.documentElement.setAttribute('data-theme', 'defaultTheme');
        }

        return {
            empresaAtual,
            listaEmpresas,
            isAdmin,
            getUserCompanyId,
            getIndexCompany,
            getCompanyRole,
            getSystemColor,
            getAcess,
            definirEmpresaAtual,
            definirListaEmpresas,
            atualizarEmpresaAtual,
            limparDadosEmpresa,
            getSystemRole,
            getId,
            getTenantId,
            setSystemTheme,
            setLogo,
            getLogo,
            removeLogo,
            applyActiveTheme
        }
    },
    {
        persist: {
            key: 'empresa-store',
            paths: ['empresaAtual', 'listaEmpresas'],
        },
    }
)
